/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "AannAahar Site",
    description:
      "Our project aims to leverage technology to reduce food waste and improve access to nutritious food, contributing to the goal of zero hunger.",
    url: "https://github.com/prernads/Zero-Hunger",
  },
  {
    title: "Breast Cancer Detection Site",
    description:
      "In this project, I aim to develop a machine learning model for early breast cancer prediction using patient data.",
    url: "https://github.com/prernads/Hackathon-SpaceSprint",
  },
  {
    title: "URL Shortener",
    description:
     "In this project, I created URL Shortener for easy sharing and tracking.",
    url: "https://github.com/prernads/url-shortener",
  },
  {
    title: "Samatva",
    description:
      "In this project, we are empowering communities through initiatives promoting gender equality.",
    url: "https://app.moqups.com/Xj6MfJgXhBV4jN0KnmSA7ViMw9UbcW7I/edit/page/ac37852f4",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
